const CLIENT_COMMON_ERROR = {
  FAILED_TO_FETCH: 'common.errors.failedToFetch',
  REQUEST_ABORTED: 'common.errors.requestAborted',
};

export default CLIENT_COMMON_ERROR;
